module.exports = __webpack_public_path__ + "img/cancun-bay-kids.84f741b7.jpg";